import Button from "./button";
import BusinessHeader from "./business-header";
import { HeroBadge } from "@components/ui";

type HeroProps = {
  data: {
    title: string;
    description: string;
    image: string;
    buttonText?: string;
    buttonOnclick?: () => void;
    buttonInput?: boolean;
    buttonInputPlaceholder?: string;
    footerText?: string;
    footerButtonText?: string;
    footerButtonOnclick?: () => void;
    footerIcon?: React.ReactNode;
  };
};

const Hero = ({ data }: HeroProps) => {
  const {
    buttonOnclick,
    buttonText,
    description,
    footerButtonOnclick,
    footerButtonText,
    footerText,
    footerIcon,
    image,
    title,
    buttonInput,
    buttonInputPlaceholder,
  } = data;

  return (
    <section
      className="relative w-full overflow-hidden"
      style={{
        background: "linear-gradient(163deg, #E39518 -15.62%, #F24D2B 88.09%)",
      }}
    >
      <div className="w-full max-w-[1728px] mx-auto flex flex-col items-start pt-6 md:pt-8 px-5 md:px-10 lg:px-16 xl:px-[121px] pb-10 md:pb-12 relative gap-6 md:gap-10 lg:gap-20 xl:gap-[145px]">
        {/* Header */}
        <div className="relative z-10 w-full mb-10">
          <BusinessHeader />
        </div>

        {/* Hero Content */}
        <div className="w-full max-w-full lg:max-w-[793px] flex flex-col items-start gap-8 md:gap-12 lg:gap-20 xl:gap-[120px] z-[3] text-white">
          <div className="flex flex-col items-start w-full gap-6 md:gap-10 lg:gap-16">
            <div className="flex flex-col items-start w-full gap-4 md:gap-6">
              <h1 className="text-[28px] sm:text-[35px] md:text-[48px] lg:text-[64px] xl:text-[76px] font-bold tracking-[-0.04em] leading-[1.1] xl:leading-[1.2]">
                {title}
              </h1>
              <p className="text-[13px] sm:text-xs md:text-base lg:text-[20px] xl:text-[24px] tracking-[-0.04em] text-white/65 leading-[1.4]">
                {description}
              </p>
            </div>

            {buttonText && (
              <div className="w-full">
                {buttonInput ? (
                  <div className="relative bg-[#F9F9FB] w-[497px] max-w-full border border-[#8B8D98] rounded-full flex gap-2 p-1.5 md:p-2 overflow-clip">
                    <input
                      type="text"
                      className="bg-transparent placeholder:italic placeholder:text-[#62636C] p-3 md:p-4 outline-none rounded-full text-black text-[13px] md:text-sm w-full"
                      placeholder={buttonInputPlaceholder}
                    />
                    <Button title={buttonText} onClick={buttonOnclick} />
                  </div>
                ) : (
                  <Button title={buttonText} onClick={buttonOnclick} />
                )}
              </div>
            )}
          </div>

          {footerText && (
            <HeroBadge
              text={footerText}
              icon={footerIcon}
              linkText={footerButtonText}
              onLinkClick={footerButtonOnclick}
            />
          )}
        </div>

        {/* Hero Image - Desktop */}
        <img
          src={image}
          alt="Gas business illustration"
          className="hidden lg:block absolute top-[200px] xl:top-[228px] right-0 w-[450px] lg:w-[550px] xl:w-[677.7px] h-auto max-h-[1368px] z-[2] opacity-70 xl:opacity-100"
        />
      </div>
    </section>
  );
};

export default Hero;
